import { createContext } from 'react';
import { LeadModalContextProps } from './LeadModal.types';

// @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
const LeadModalContext = createContext<LeadModalContextProps>(undefined);

export default LeadModalContext;
